<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="en" page="blue" />
    <main>
      <section class="hero-section">
        <div class="hero-copy">
          <h1>Download Blue WhatsApp v18.80 Latest Version</h1>
          <p class="hero-text">
            Download Blue WhatsApp APK and enjoy a more personalized WhatsApp experience with custom themes, extra privacy controls, Status Downloader, and useful messaging features.
          </p>
          <div class="hero-actions">
            <img class="hero-logo" src="@/assets/mods/blue.webp" alt="Blue WhatsApp logo" width="128" height="128">
            <div class="hero-chips" aria-label="Download highlights">
              <span v-for="chip in heroChips" :key="chip.label">
                <span class="hero-chip-icon" aria-hidden="true">{{ chip.icon }}</span>
                {{ chip.label }}
              </span>
            </div>
            <button class="primary-action" type="button" @click="download">
              <svg class="primary-action__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3v10.7m0 0 4.2-4.2M12 13.7 7.8 9.5M5 17.5V20h14v-2.5" />
              </svg>
              <span>Blue WhatsApp V18.80 Download</span>
            </button>
          </div>
        </div>
        <div class="hero-visual">
          <PhoneGallery class="hero-gallery" theme="blue" variant="blue" />
        </div>
      </section>

      <AlternativesGrid title="Alternatives to Blue WhatsApp" :items="alts" />

      <section class="content-section">
        <h2>Blue WhatsApp APK</h2>
        <p>Blue WhatsApp APK is a modified version of WhatsApp for Android that focuses on customization, privacy controls, and extra messaging features. It keeps the familiar WhatsApp experience while adding options such as custom themes, hidden online status, Status downloading, Anti-Delete Messages, and additional chat controls.</p>
        <p>Unlike official WhatsApp, Blue WhatsApp is distributed as an APK and is not an official Meta application. Different Blue WhatsApp builds are available online, so version numbers and features can vary between releases.</p>
      </section>

      <section class="content-section">
        <h2>What Makes Blue WhatsApp Different?</h2>
        <p>The most obvious difference is the level of customization. Blue WhatsApp is known for its blue-themed interface, but users can also find different themes, fonts, chat styles, colors, and layout options depending on the build.</p>
        <p>Privacy is another major reason people look for Blue WhatsApp. Common options include hiding your online status, freezing last seen, hiding blue ticks and typing indicators, and viewing certain deleted messages.</p>
        <p>It also adds practical tools that some users find missing from official WhatsApp, such as Status downloading, message scheduling, Auto Reply, App Lock, and expanded media-sharing options.</p>
      </section>

      <section class="content-section">
        <h2>Blue WhatsApp APK Info</h2>
        <SimpleTable caption="Blue WhatsApp APK info" :columns="infoCols" :rows="infoRows" />
        <p>If two websites show different version numbers, do not assume that the higher number is automatically the newer or safer one. Check the release information, package name, file size, and source before installing.</p>
      </section>

      <section class="content-section">
        <h2>Features You Can Use in Blue WhatsApp</h2>
        <div class="two-col-cards">
          <article v-for="feature in features" :key="feature.title">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.text }}</p>
          </article>
        </div>
      </section>

      <section id="installation-guide" class="content-section">
        <h2>How to Download and Install Blue WhatsApp on Android</h2>
        <p>Before installing Blue WhatsApp, create a backup of important WhatsApp chats and media. Do not rely on the APK installation itself to protect your existing conversations.</p>
        <ol class="install-timeline">
          <li v-for="(step, index) in installSteps" :key="step.title" class="install-timeline__item">
            <div class="install-timeline__marker" aria-hidden="true">{{ index + 1 }}</div>
            <div class="install-timeline__content">
              <strong>{{ step.title }}</strong>
              <p>{{ step.text }}</p>
            </div>
          </li>
        </ol>
        <p>If verification does not work, avoid repeatedly reinstalling different APKs. Check your connection, phone number, APK build, and whether your account has been restricted.</p>
      </section>

      <section class="content-section">
        <h2>Can You Use Blue WhatsApp Alongside Official WhatsApp?</h2>
        <p>Sometimes, but it depends on the specific Blue WhatsApp build and package configuration.</p>
        <p>Some WhatsApp mods use a different package name, allowing them to be installed alongside the official WhatsApp. However, this does not automatically mean that both apps can safely use the same phone number at the same time.</p>
        <p>If your goal is to keep official WhatsApp and test Blue WhatsApp separately, using a second number is the simpler approach. If you are moving your main account, back up your chats before making the switch.</p>
      </section>

      <section class="content-section">
        <h2>Blue WhatsApp vs Green WhatsApp: What Do You Actually Get?</h2>
        <SimpleTable caption="Blue WhatsApp vs Green WhatsApp" :columns="compareCols" :rows="compareRows" />
        <p>The choice comes down to what you value. Blue WhatsApp gives you more freedom to change how the app looks and behaves, while official WhatsApp gives you official updates, support, and a more predictable account experience.</p>
      </section>

      <section class="content-section">
        <h2>Is Blue WhatsApp Safe to Use?</h2>
        <p>Blue WhatsApp should be treated as an unofficial third-party WhatsApp client, not as an official alternative from Meta.</p>
        <p>The biggest practical concern is the APK itself. Because modified apps are distributed outside Google Play, users need to pay attention to where the file comes from and what permissions it requests. Research into modified Android applications has also found increased security risks compared with official apps.</p>
        <p>There is also an account risk. WhatsApp has historically taken action against accounts using modified clients, and community discussions continue to include reports of users experiencing restrictions while using WhatsApp mods.</p>
        <p>For that reason, features described as <strong>Anti-Ban</strong> should not be treated as a guarantee that your account is protected.</p>
      </section>

      <section class="content-section">
        <h2>What Happens If Blue WhatsApp Stops Working?</h2>
        <p>A Blue WhatsApp installation can stop working for several reasons, including an outdated build, verification problems, compatibility issues, or changes made by WhatsApp.</p>
        <p>Try these checks first:</p>
        <ul>
          <li>Check whether a newer compatible build is available.</li>
          <li>Make sure your Android version is supported.</li>
          <li>Check your internet connection and phone storage.</li>
          <li>Restart the app and your phone.</li>
          <li>Clear the app cache.</li>
          <li>If verification fails, check whether your number has been restricted.</li>
          <li>Back up your chats before uninstalling or changing the APK.</li>
        </ul>
        <p>If the app suddenly says that you need to use the official WhatsApp, installing another random mod is not necessarily the answer. The issue may be related to WhatsApp's verification system rather than your phone.</p>
      </section>

      <section class="content-section">
        <h2>Blue WhatsApp Account Ban: What You Should Know</h2>
        <p>Using Blue WhatsApp carries a greater account risk than using the official WhatsApp app. An Anti-Ban option may be advertised by a particular build, but there is no reliable way for a third-party mod to guarantee that WhatsApp will never restrict an account.</p>
        <p>Community discussions show that users of WhatsApp mods have reported temporary and permanent account restrictions, although a ban can have different causes and an individual report does not prove why every account was restricted.</p>
        <p>If your number is important for work, school, banking alerts, or family communication, think carefully before using a modded client. Keeping a current backup makes it easier to return to official WhatsApp if necessary.</p>
      </section>

      <section class="content-section">
        <h2>Blue WhatsApp on Android, iPhone, and PC</h2>
        <div class="card-grid">
          <article v-for="platform in platforms" :key="platform.title">
            <h3>{{ platform.title }}</h3>
            <p v-html="platform.text"></p>
          </article>
        </div>
      </section>

      <FaqList title="FAQ" :items="faqs" />
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import AlternativesGrid from '@/components/AlternativesGrid.vue';
import FaqList from '@/components/FaqList.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import PhoneGallery from '@/components/PhoneGallery.vue';
import apkDownload from '@/mixins/apkDownload';
import { getAlternatives } from '@/content/mods';

export default {
  name: 'BlueWhatsApp',
  components: { HeadNav, AlternativesGrid, FaqList, SimpleTable, PhoneGallery },
  mixins: [apkDownload],
  data() {
    return {
      heroChips: [
        { icon: '🎁', label: 'Free' },
        { icon: '🛡️', label: 'Safe Download' },
        { icon: '✓', label: 'Latest Version' },
        { icon: '⚡', label: 'Fixed Login' },
      ],
      alts: getAlternatives('blue'),
      infoCols: ['Information', 'What to Check'],
      infoRows: [
        ['App Name', 'Blue WhatsApp / Blue WhatsApp Mod'],
        ['Version', 'v18.80'],
        ['Platform', 'Android'],
        ['Format', 'APK'],
        ['Google Play', 'Not officially available'],
        ['Root Required', 'Usually not required'],
        ['Price', 'Generally free'],
        ['Main Focus', 'Privacy, themes, customization, and extra messaging tools'],
      ],
      features: [
        { icon: '🎨', title: 'Blue Themes and Custom Interface', text: 'Blue WhatsApp is especially popular with users who do not want to stick with the standard green WhatsApp design. You can change themes, colors, chat backgrounds, fonts, and other interface elements, depending on the build.' },
        { icon: '🙈', title: 'Hide Online Status', text: 'You can hide your online presence so contacts do not immediately know when you are using WhatsApp. This is useful if you want to read messages or browse chats without feeling pressured to reply right away.' },
        { icon: '❄️', title: 'Freeze Last Seen', text: 'The Freeze Last Seen option can keep your last-seen information from changing while you continue using the app. It gives you more control over what activity information is visible to other contacts.' },
        { icon: '✓', title: 'Hide Blue Ticks and Typing Status', text: 'Blue WhatsApp can give you more control over read receipts and typing indicators. You can read a message or type a reply without necessarily showing the same activity indicators used by standard WhatsApp.' },
        { icon: '💬', title: 'Anti-Delete Messages', text: 'With Anti-Delete Messages, certain messages can remain visible even after the sender deletes them. This can be useful when someone removes a message before you get a chance to read it, although the feature cannot recover everything that was deleted before it was enabled.' },
        { icon: '⬇️', title: 'Status Downloader', text: 'Blue WhatsApp can let you save photos and videos from WhatsApp Status directly to your device. You do not need to ask the contact to send the same image or video separately.' },
        { icon: '🗓️', title: 'Message Scheduler', text: 'Message Scheduler lets you prepare a message and set a time for it to be sent. It can be useful for birthday wishes, reminders, or messages you know you need to send later.' },
        { icon: '🤖', title: 'Auto Reply', text: 'Auto Reply can send a predefined response when you are unavailable. It is more useful for people who receive regular messages and want to let others know that they will respond later.' },
        { icon: '🔏', title: 'App Lock and Chat Privacy', text: 'Some Blue WhatsApp builds include App Lock or additional chat-protection options. This gives you another way to prevent someone who has access to your unlocked phone from opening your WhatsApp conversations.' },
        { icon: '📦', title: 'Larger Media Sharing', text: "Several Blue WhatsApp builds advertise larger file and media-sharing limits than official WhatsApp. The exact limit depends on the build, so it is better to check the current APK's feature list rather than relying on a fixed number." },
        { icon: '🖼️', title: 'HD Media Sharing', text: 'Some recent Blue WhatsApp builds offer higher-quality photo and video sharing. This is useful when you want the recipient to receive clearer media instead of heavily compressed images.' },
        { icon: '👥', title: 'Multiple Accounts', text: 'Some builds provide options for running more than one WhatsApp account on the same Android phone. This can be convenient if you use separate numbers for personal and other conversations, although support depends on the specific build.' },
      ],
      platforms: [
        { icon: '📱', title: 'Android', text: 'Android is the main platform for Blue WhatsApp because the app is distributed as an APK. Installation can be done manually on a compatible Android device.' },
        { icon: '🍎', title: 'iPhone', text: 'There is no normal Blue WhatsApp APK installation method for iPhone. APK files are designed for Android, so websites offering a simple <strong>Blue WhatsApp APK for iPhone</strong> download should be treated cautiously.' },
        { icon: '💻', title: 'Windows and Mac', text: 'Blue WhatsApp is not a native Windows or Mac application. If you need WhatsApp on a computer, the official WhatsApp Web or desktop client is the more straightforward option.' },
        { icon: '📲', title: 'Android Tablets', text: 'Blue WhatsApp may work on some Android tablets, but compatibility depends on the Android version, device configuration, and how the specific build handles phone-number verification.' },
      ],
      installSteps: [
        {
          title: 'Back up your chats',
          text: 'Open your current WhatsApp and create a recent backup. If certain photos, videos, or documents are particularly important, save separate copies as well.',
        },
        {
          title: 'Download the Blue WhatsApp APK',
          text: 'Check the exact version and APK information before downloading. Avoid files that are repackaged with unrelated applications or require unnecessary permissions.',
        },
        {
          title: 'Allow APK installation',
          text: 'Android may ask you to allow your browser or file manager to install apps from unknown sources. Enable the permission for the app you are using, then return to the APK.',
        },
        {
          title: 'Install Blue WhatsApp',
          text: 'Open the APK file and follow the Android installation prompts. Once installation finishes, launch Blue WhatsApp.',
        },
        {
          title: 'Verify your number',
          text: 'Enter your WhatsApp phone number and complete verification. If the build supports your existing backup, follow the available restore instructions.',
        },
      ],
      compareCols: ['Feature', 'Blue WhatsApp', 'Green WhatsApp'],
      compareRows: [
        ['Custom Themes', 'More options', 'Limited'],
        ['Custom Fonts', 'Available in supported builds', 'Limited'],
        ['Hide Online Status', 'More controls', 'Standard controls'],
        ['Freeze Last Seen', 'Available in some builds', 'No'],
        ['Anti-Delete Messages', 'Available in supported builds', 'No'],
        ['Status Downloader', 'Built-in in some builds', 'No standard feature'],
        ['Message Scheduler', 'Available in some builds', 'No standard feature'],
        ['Auto Reply', 'Available in some builds', 'Limited/Business-focused options'],
        ['Large Media Sharing', 'Expanded in some builds', 'Official limits apply'],
        ['Google Play', 'No official listing', 'Yes'],
        ['Official Support', 'No', 'Yes'],
        ['Account Risk', 'Higher', 'Lower'],
      ],
      faqs: [
        { question: 'Can I use Blue WhatsApp with my current WhatsApp number?', answer: 'Yes, a Blue WhatsApp build may allow you to verify your existing WhatsApp number. However, using a modified client carries more account risk than using the official app.' },
        { question: 'Can I install Blue WhatsApp without losing my chats?', answer: 'You should back up your chats before installing or replacing WhatsApp. Whether a backup can be restored depends on the specific Blue WhatsApp build and backup method.' },
        { question: "Why can't I find Blue WhatsApp on Google Play?", answer: 'Blue WhatsApp is a modified third-party WhatsApp client, so it is not distributed as an official Google Play application.' },
        { question: 'Can Blue WhatsApp download WhatsApp Status?', answer: 'Many Blue WhatsApp builds include a Status Downloader that lets you save photos and videos from Status updates.' },
        { question: 'Can I switch back to official WhatsApp?', answer: 'Yes. Before switching back, make sure your chats and important media are backed up. Then install official WhatsApp and complete the normal verification and restore process.' },
        { question: 'Does Blue WhatsApp support two accounts?', answer: 'Some builds include multiple-account options, but this feature is not guaranteed across every Blue WhatsApp release. Check the feature list of the specific APK you plan to install.' },
        { question: 'Why is my Blue WhatsApp verification code not arriving?', answer: "Check your phone number, mobile signal, SMS reception, and internet connection first. If the build is no longer accepted by WhatsApp's verification system or your number has been restricted, reinstalling the APK may not solve the problem." },
        { question: 'Is Blue WhatsApp free?', answer: 'Most Blue WhatsApp APK builds are distributed as free downloads. Be careful if a website asks you to pay or install unrelated software just to obtain the APK.' },
        { question: 'Is Blue WhatsApp the same as Blue WhatsApp Plus?', answer: 'Not necessarily. Different websites use the names <strong>Blue WhatsApp</strong>, <strong>Blue WhatsApp Plus</strong>, and <strong>Blue WhatsApp Mod</strong> for different builds. Check the developer, package name, version, and source before assuming two APKs are the same application.' },
      ],
    };
  },
};
</script>
